import React from "react";
import styles from "./styles.module.scss";

const Container = ({ title, headerAction, children }) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div
          className={`${styles.contentHeader} ${
            headerAction ? styles.withAction : ""
          }`}
        >
          <p>{title}</p>
          {headerAction}
        </div>
        {children}
      </div>
    </div>
  );
};

export default Container;
